import { Grid, ResponsiveSection, Text } from '@stitch-fix/mode-react';
import type { BrandsValuePageData } from '../../types';
import styles from './index.module.scss';
interface PricingSectionProps {
  data: BrandsValuePageData['pricing'];
}
export const PricingSection = ({
  data
}: PricingSectionProps) => {
  return <section className={styles.section}>
      <ResponsiveSection width="xlarge" gutter="standard">
        <div className={styles.container}>
          {data.eyebrow ? <Text as="p" className={styles.eyebrow} setting="eyebrow-medium">
              {data.eyebrow}
            </Text> : null}
          <Text as="h2" className={styles.title} setting="title-xxlarge">
            {data.title}
          </Text>
          <Text as="p" className={styles.supportingText} setting="body-small-fixed">
            {data.supportingText}
          </Text>

          <div className={styles.gridWrap}>
            <Grid columns={{
            sm: 1,
            lg: 3
          }} spacing="standard">
              {data.cards.map(card => <div className={styles.card} data-accent={card.accent} key={card.id}>
                  <Text as="p" className={styles.cardEyebrow} setting="eyebrow-medium">
                    {card.eyebrow}
                  </Text>
                  <Text as="h3" className={styles.cardTitle} setting="title-large">
                    {card.title}
                  </Text>
                  <Text as="p" className={styles.cardDescription} setting="body-medium">
                    {card.description}
                  </Text>
                </div>)}
            </Grid>
          </div>
        </div>
      </ResponsiveSection>
    </section>;
};